import { TaxB2PComponent } from './tax-b2p.component';
export var taxB2PRoutes = [
    {
        path: 'taxB2P',
        component: TaxB2PComponent
    }
];
var TaxB2PRoutingModule = (function () {
    function TaxB2PRoutingModule() {
    }
    return TaxB2PRoutingModule;
}());
export { TaxB2PRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/tax-b2p/tax-b2p-routing.module.ts.pre-build-optimizer.js